import axios        from "axios";
import {url_path}   from "./paths";

export default {
    state: {
        sharedLayers: [ ],
        sharedLayersNotEmpty: [ ],
        current_shared_layer:{
            layer:{
                id: 0,
                name: ''
            }
        },
        password: ''
    },
    mutations: {
        setSharedLayersList (state, payload) {
            state.sharedLayers = payload;
        },
        setSharedNotEmpty (state, payload) {
            state.sharedLayersNotEmpty = payload;
        },
        setCurrentSharedLayer (state, payload) {
            state.current_shared_layer = payload;
        },
        setPassword (state, payload) {
            state.password = payload;
        },
    },
    actions: {
        async getSharedLayers ({commit}, {slugid, password = ''}) {
            commit('clearError');
            commit('setLoading', true);
            if (password != '') commit('setPassword', password);
            try {
                const response = await axios.get(url_path.url_share_layers_list + slugid + '?password=' + password);

                if (response.data.status == url_path.response_status_ok){
                    commit('setSharedLayersList', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                }
            }
            catch (error) {
                commit('setLoading', false);
                commit('setError', error.message);
                throw error
            }
        },
        setSharedNotEmpty ({commit}, payload) {
            commit('setSharedNotEmpty', payload);
        },
        async getCurrentSharedLayer ({commit}, {slugid, id, show_geo, password, low_quality, pypreload}) {
            commit('clearError');
            commit('setLoading', true);
            let add_geo = '?low_quality=' + low_quality;
            add_geo += '&pypreload=' + pypreload;
            add_geo += '&show_geo=1&password=' + password;
            try {
                await axios.get(url_path.url_share_layers_view + slugid + '/' + id + add_geo)
                .then((response) => {

                    if (response.data.status == url_path.response_status_ok){
                        response.data.data.documents = [];
                        for (const [key, value] of Object.entries(response.data.data.info)) {
                            response.data.data.documents.push(value);
                        }
                        commit('setCurrentSharedLayer', response.data.data);
                        commit('setLoading', false);
                    }
                    else {
                        commit('setLoading', false);
                    }

                })
                .catch(() => {});
            }
            catch (error) {
                commit('setLoading', false);
                commit('setError', error.message);
                throw error
            }
        },
    },
    getters: {
        shared_layers (state){
            return state.sharedLayers;
        },
        shared_not_empty (state){
            return state.sharedLayersNotEmpty;
        },
        currentSharedLayer (state) {
            return state.current_shared_layer;
        },
        password (state) {
            return state.password;
        },
    }
}
